export const actionTypes = {
  SET_QUOTATION_RELEASE_LIST: "SET_QUOTATION_RELEASE_LIST",
  SET_QUOTATION_RELEASE_DETAIL: "SET_QUOTATION_RELEASE_DETAIL",
  SET_QUOTATION_RELEASE_HISTORY_LIST: "SET_QUOTATION_RELEASE_HISTORY_LIST",
  SET_DOC_RELEASE_LIST: "SET_DOC_RELEASE_LIST",
  SET_DOC_RELEASE_HISTORY_LIST: "SET_DOC_RELEASE_HISTORY_LIST",
  SET_FAQ_RELEASE_LIST: "SET_FAQ_RELEASE_LIST",
};